module.exports = __webpack_public_path__ + "static/img/title.9eb3e78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/eggenberger/title.jpg
// module id = 367
// module chunks = 1